import { NavItemType } from '@/router/type'

const patientRouterItems: NavItemType[] = [
  {
    id: 'patient',
    title: 'Paciente',
    icon: 'user',
    type: 'collapse',
    pathname: '/paciente',
    children: [
      {
        id: 'blocked-cpfs',
        title: 'CPFs bloqueados',
        url: '/paciente/cpfs-bloqueados',
        type: 'item',
      },
    ],
  },
]

export default patientRouterItems
